module.exports = __webpack_public_path__ + "static/media/5.0f3c5b8f.jpg";